import React, { useEffect } from "react";
import cx from "classnames";
import Select, { Option } from "rc-select";
import Icon from "components/CommonIcon/Icon";
import "./select.less";

export const SelectOption = ({ value, children }) => (
  <Option
    className="font-mulish text-14 text-gray-text leading-16 border-b border-gray-med w-full px-12 py-16 cursor-default"
    value={value}>
    {children}
  </Option>
);

const SelectCustom = ({ className, children, ...props }) => {
  useEffect(() => {
    if (props.defaultValue) props.onChange(props.defaultValue);
  }, []);

  return (
    <Select
      className={cx("rc-select w-full font-mulish", className)}
      inputIcon={<Icon name="chevron-down" fontSize="text-12" />}
      menuItemSelectedIcon={null}
      {...props}>
      {children}
    </Select>
  );
};
SelectCustom.defaultProps = {
  className: "",
};

export default SelectCustom;
